<template>
  <div id="userdetail-page" class="mb-5">
    <b-card>
      <b-row>
        <b-col md="12">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/sales/invoice">Invoice</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="border-bottom"></div>
        </b-col>
      </b-row>
      <form v-on:submit.prevent="doEdit()" class="mt-3">
        <div>
          <b-row>
            <b-col md="5 mb-1">
              <label class="labels">No. Invoice</label>
              <div class="form-group w-50 d-flex">
                <input
                  type="text"
                  class="form-control"
                  v-model="model.invoiceId"
                  placeholder="No. Invoice"
                />
                <!-- <span class="text-secondary text-bold mt-1 ml-1">
                  {{
                    '/' + 'MKT' + '/' + 'QT' + '/' + romanize(getMonth()) + '/' + getFullYear()
                  }}</span
                > -->
              </div>
            </b-col>
            <b-col md="2"></b-col>
            <b-col md="5">
              <label class="labels">Invoice Date</label>
              <div
                class="form-group"
                v-bind:class="errors.has('invoiceStartDate') ? 'has-error' : ''"
              >
                <b-form-datepicker
                  type="date"
                  :min="min"
                  class="form-control"
                  v-bind:class="errors.has('invoiceStartDate') ? 'is-invalid' : ''"
                  data-vv-as="invoiceStartDate"
                  name="invoiceStartDate"
                  v-model="model.invoiceStartDate"
                  placeholder="Date"
                />
                <p v-if="errors.has('invoiceStartDate') !== null"></p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="5">
              <label class="labels">PIC *</label>
              <div class="form-group" v-bind:class="errors.has('pic') ? 'has-error' : ''">
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="errors.has('pic') ? 'is-invalid' : ''"
                  v-validate="'required'"
                  data-vv-as="pic"
                  name="pic"
                  v-model="model.invoicePic"
                  placeholder="PIC Name"
                />
                <p v-if="errors.has('pic') !== null"></p>
              </div>
            </b-col>
            <b-col md="2"></b-col>
            <b-col md="5">
              <label class="labels">Customer *</label>
              <v-select
                id="mySelect"
                label="text"
                v-model="model.customer"
                :options="customerList"
                :reduce="(text) => text.value"
                class="style-chooser"
                placeholder="search customer..."
              >
                <template #search="{attributes, events}">
                  <input
                    class="vs__search"
                    :required="!model.customer"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="5">
              <label for="" class="labels">Bank Account *</label>
              <v-select
                id="mySelect"
                label="text"
                v-model="model.bankAccount"
                :options="bankList"
                :reduce="(text) => text.value"
                class="style-chooser"
                placeholder="search bank account"
              >
                <template #search="{attributes, events}">
                  <input
                    class="vs__search"
                    :required="!model.bankAccount"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
            </b-col>
            <b-col md="5 mb-1"> 
            </b-col>
          </b-row>
          <b-row>
            <b-col md="5 mb-1"> </b-col>
            <b-col md="2"> </b-col>
            <b-col md="5 mb-1"> </b-col>
          </b-row>
          <b-row>
            <b-col md="5 mb-1"> </b-col>
            <b-col md="2"></b-col>
            <b-col md="5 mb-1"> </b-col>
          </b-row>
          <div class="border-bottom"></div>

          <b-row class="mt-3">
            <b-col class="mt-3">
              <div class="table-responsive table-borderless">
                <table>
                  <thead>
                    <tr class="small-text border-bottom py-5">
                      <th width="60">No</th>
                      <th width="300">Item *</th>
                      <th class="text-center" width="160">Quantity *</th>

                      <th v-if="customerValue == 'Personal'" class="text-center" width="200">
                        Normal Price
                      </th>
                      <th v-if="customerValue == 'Corporate'" class="text-center" width="200">
                        Corporate Price
                      </th>
                      <th class="text-center" width="200">
                        Edit Price
                      </th>
                      <th class="text-center" width="140">Discount (%)</th>
                      <th class="text-center" width="250">Amount</th>
                      <!-- <th class="text-center" width="150"></th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(selectedItem, index) in selectedItems">
                      <tr v-if="!selectedItem.isDeleted" :key="selectedItem.uuid">
                        <!-- no -->
                        <td>
                          <b-form-input
                            class=" mt-3 small-text selected bg-white"
                            :value="index + 1"
                            readonly
                          >
                          </b-form-input>
                        </td>
                        <!-- item -->
                        <td>
                          <b-form-input
                            style="white-space: pre-line;"
                            v-model="selectedItem.name"
                            :plaintext="selectedItem.isCustomItem"
                            required
                            class="mt-3 selected small-text"
                            placeholder="Enter Item"
                          />
                        </td>
                        <!-- quantity -->
                        <td>
                          <b-form-input
                            v-model="selectedItem.orderQuantity"
                            type="number"
                            required
                            class="mt-3 text-center selected small-text"
                            style="margin-top:15px!important;"
                            placeholder="Enter Quantity"
                          />
                        </td>
                        <!-- unit price -->
                        <td v-if="customerValue == 'Personal'">
                          <b-form-input
                            v-model="selectedItem.normalPrice"
                            :plaintext="!selectedItem.isCustomItem"
                            type="number"
                            required
                            class="mt-3 text-center selected small-text"
                            placeholder="Enter Unit Price"
                          />
                        </td>
                        <td v-if="customerValue == 'Corporate'">
                          <b-form-input
                            v-model="selectedItem.corporatePrice"
                            :plaintext="!selectedItem.isCustomItem"
                            type="number"
                            required
                            class="mt-3 text-center selected small-text"
                            placeholder="Enter Unit Price"
                          />
                        </td>
                        <td width="140">
                          <!-- <b-form-input
                            v-model="selectedItem.price"
                            :plaintext="selectedItem.isCustomItem"
                            type="number"
                            class="mt-3 text-center selected small-text"
                            placeholder="Enter Price"
                          /> -->
                          <my-currency-input 
                          v-model="selectedItem.price"
                          :value="0"
                          class="mt-3 text-center selected small-text"
                          :plaintext="selectedItem.isCustomItem"
                          ></my-currency-input>
                        </td>

                        <!-- discount -->
                        <td>
                          <b-form-input
                            v-model="selectedItem.discount"
                            type="number"
                            value="0"
                            min="0"
                            max="70"
                            class="mt-3 text-center selected small-text"
                            style="margin-top:15px!important;"
                            placeholder="Discount in %"
                          />
                        </td>
                        <!-- amount -->
                        <div
                          v-if="
                            (selectedItem.customPrice > 0) & (selectedItem.customPrice !== null)
                          "
                        >
                          <td>
                            <b-form-input
                              :value="selectedItem.orderQuantity * selectedItem.customPrice"
                              plaintext
                              type="number"
                              class="mt-3 text-center selected small-text"
                            />
                          </td>
                        </div>
                        <div v-else>
                          <td v-if="customerValue == 'Personal'">
                            <b-form-input
                              :value="selectedItem.orderQuantity * selectedItem.normalPrice"
                              plaintext
                              type="number"
                              class="mt-3 text-center selected small-text"
                            />
                          </td>
                          <td v-if="customerValue == 'Corporate'">
                            <b-form-input
                              :value="selectedItem.orderQuantity * selectedItem.corporatePrice"
                              plaintext
                              type="number"
                              class="mt-3 text-center selected small-text"
                            />
                          </td>
                        </div>

                        <td class="text-center p-0">
                          <b-button
                            pill
                            v-b-tooltip.hover.right
                            title="Delete Row"
                            style="margin-bottom:5px!important;font-weight:bold!important;padding-top:0px!important; padding-bottom:0px!important;"
                            size="sm"
                            variant="danger"
                            @click="() => deleteFromSelectedItems(index)"
                          >
                            x
                          </b-button>
                        </td>
                        <td></td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <!-- dropdown autocomplete to search items -->
            <b-col md="6">
              <b-dropdown text="Add Item" variant="dark">
                <div
                  style="overflow: scroll; height: 250px; width:489px; border-bottom: 1px solid black"
                >
                  <v-select
                    multiple
                    v-model="selectedItems"
                    style="width: 100%;"
                    id="mySelect"
                    label="name"
                    @input="addToSelected(availableItem.uuid)"
                    :options="availableItems"
                    :reduce="(uuid) => uuid"
                    class="style-chooser mt-1"
                    placeholder="Type to search Items"
                  ></v-select>
                  <b-dropdown-divider></b-dropdown-divider>
                </div>
              </b-dropdown>
            </b-col>
            <!-- ===================================================================================
                
                CALCULATOR JCK
              
             ================================================================================== -->

            <b-col md="6">
              <b-card no-body>
                <b-tabs content-class="mt-3" lazy card>
                  <b-tab title="Calc Price" active>
                    <b-row>
                      <b-col md="3 mt-1">
                        <p id="value" class="value-row"><b>Sub Total:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="9" v-if="customerValue === 'Personal'">
                        <p id="value" class="tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getSubtotalPersonal()) }}</b
                          >
                        </p>
                      </b-col>
                      <b-col md="3" v-if="customerValue === 'Corporate'">
                        <p id="value" class="tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getSubtotalCorporate()) }}</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                    <!-- ===== batass cuyy ======-->
                    <b-row>
                      <b-col md="3 mt-1">
                        <p id="value" class="value-row"><b>Disc Total:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="9" v-if="customerValue === 'Personal'">
                        <p id="value" class="tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getDiscTotalPersonal()) }}</b
                          >
                        </p>
                      </b-col>
                      <b-col md="9" v-if="customerValue === 'Corporate'">
                        <p id="value" class="tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getDiscTotalCorporate()) }}</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                    <!-- ====== batas cuyy ========= -->
                    <b-row>
                      <b-col md="3 mt-1">
                        <p id="value" class="value-row"><b>Total:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="9" v-if="customerValue === 'Personal'">
                        <p id="value" class="tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTotalPersonalOrder()) }}</b
                          >
                        </p>
                      </b-col>
                      <b-col md="9" v-if="customerValue === 'Corporate'">
                        <p id="value" class="tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTotalCorporateOrder()) }}</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                    <!-- ==== batas cuyy ==== -->
                    <b-row>
                      <b-col md="2 mt-3">
                        <p class="tax-values"><b>Tax *:</b></p>
                      </b-col>
                      <b-col md="3">
                        <b-form-select
                          class="form-control float-right tax-list"
                          v-model="model.taxValue"
                          :options="taxList"
                        >
                        </b-form-select>
                      </b-col>
                      <b-col md="1">
                        <b-button
                          v-b-tooltip.hover.top
                          title="Add Tax"
                          size="sm"
                          id="btn-add"
                          @click="showModalTax()"
                          ><font-awesome-icon icon="plus"
                        /></b-button>
                      </b-col>
                    </b-row>
                    <!-- ==== batas bang ===== -->
                    <b-row>
                      <b-col md="3 mt-1">
                        <p id="value" class="value-row"><b>Total Tax:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="9" v-if="customerValue === 'Personal'">
                        <p
                          id="value"
                          class="tax-value"
                          style="font-size:12px!important; margin-top:12px!important;"
                        >
                          <b
                            >+ ({{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTaxValuesPersonal()) }})</b
                          >
                        </p>
                      </b-col>
                      <b-col md="9" v-if="customerValue === 'Corporate'">
                        <p
                          id="value"
                          class="tax-value"
                          style="font-size:12px!important; margin-top:12px!important;"
                        >
                          <b
                            >+ ({{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTaxValuesCorporate()) }})</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                    <!-- ========== batass ============ -->
                    <b-row>
                      <b-col md="3 mt-1">
                        <p id="value" class="value-row" style="font-size:18px!important;">
                          <b class="text-primary text-bold">Grant Total:</b>
                        </p>
                        <hr class="hr-tax" width="227%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="9">
                        <span
                          id="value"
                          v-if="customerValue === 'Personal'"
                          class="tax-value mt-2"
                          style="font-size:18px!important;"
                        >
                          <h5 class="text-bold mt-2">
                            {{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTotalPersonal()) }}
                          </h5>
                        </span>
                        <span
                          id="value"
                          v-if="customerValue === 'Corporate'"
                          class="tax-value mt-2"
                          style="font-size:18px!important;"
                        >
                          <h5 class="text-bold mt-2">
                            {{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTotalCorporate()) }}
                          </h5>
                        </span>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Calc edit price">
                    <b-row>
                      <b-col md="2 mt-1">
                        <p id="value" class="value-row"><b>Sub Total:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="3">
                        <p id="value" class="float-right tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getSubtotalCustom()) }}</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="2 mt-1">
                        <p id="value" class="value-row"><b>Disc Total:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="3">
                        <p id="value" class="float-right tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getDiscTotalCustom()) }}</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="2 mt-1">
                        <p id="value" class="value-row"><b>Total:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="3">
                        <p id="value" class="float-right tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTotalCustomOrder()) }}</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="2 mt-1">
                        <p id="value" class="value-row"><b>Total Tax:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="3">
                        <p
                          id="value"
                          class="float-right tax-value"
                          style="font-size:12px!important; margin-top:12px!important;"
                        >
                          <b
                            >+ ({{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTaxValuesCustom()) }})</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3 mt-1">
                        <p id="value" class="value-row" style="font-size:18px!important;">
                          <b class="text-primary text-bold">Grant Total:</b>
                        </p>
                        <hr class="hr-tax" width="227%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="4">
                        <span
                          id="value"
                          class="float-right tax-value"
                          style="font-size:18px!important;"
                        >
                          <h5 class="text-bold">
                            {{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTotalCustom()) }}
                          </h5>
                        </span>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
              </b-card>
            </b-col>

            <!-- ====================  end CALC JCK ======================================== -->
          </b-row>
          <b-row class="mt-5">
            <b-col md="5">
              <label class="labels">Note </label>
              <textarea
                class="form-control h-100"
                v-model="model.note"
                placeholder="Enter something..."
              />
            </b-col>
            <b-col md="1"></b-col>
            <b-col md="6">
              <!--  -->
            </b-col>
          </b-row>
          <b-card class="mt-5 mb-4 bordered-card" bg-variant="light">
            <b-row>
              <b-col md="5">
                <b-card class="border-none">
                  <label class="labels">Due Date</label>
                  <div class="form-group" v-bind:class="errors.has('dueDate') ? 'has-error' : ''">
                    <b-form-datepicker
                      type="date"
                      :min="min"
                      class="form-control"
                      v-bind:class="errors.has('dueDate') ? 'is-invalid' : ''"
                      data-vv-as="dueDate"
                      name="dueDate"
                      v-model="model.invoiceDueDate"
                      placeholder="Date"
                    />
                    <p v-if="errors.has('dueDate') !== null"></p>
                  </div>
                  <label class="labels">Created By</label>
                  <div class="font-weight-bold">
                    {{ $store.getters['account/accountData'].firstName }}
                    {{ $store.getters['account/accountData'].lastName }}
                  </div>

                  <!-- <wysiwyg
                    v-model="model.termCondition"
                    placeholder="Enter term and conditions..."
                  /> -->
                </b-card>
              </b-col>
              <b-col md="3"> </b-col>
              <b-col md="4" class="mt-3">
                <label class="labels">Signed By *</label>
                <b-form-select
                  name="employee"
                  required
                  v-model="model.signedBy"
                  :options="employeeList"
                >
                </b-form-select>
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="model.isSigned"
                  name="checkbox-1"
                  :value="model.isSigned"
                  unchecked-value="0"
                  class="mt-2"
                >
                  Signature
                </b-form-checkbox>
                <b-form-checkbox
                  id="checkbox-2"
                  v-model="model.isStamp"
                  name="checkbox-2"
                  :value="model.isStamp"
                  unchecked-value="0"
                  class="mt-2"
                >
                  Stamp
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="5"> </b-col>
            </b-row>
          </b-card>
          <b-row class="mt-3">
            <b-col md="6">
              <b-button class="mr-2" @click="goBack" variant="secondary"
                ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
              >
            </b-col>
            <b-col md="6">
              <div v-if="loadingButton" class="float-right">
                <b-button variant="warning" disabled>
                  <b-spinner small type="grow"></b-spinner>
                  Loading...
                </b-button>
              </div>
              <div v-else>
                <b-button
                  :variant="$route.params.id !== undefined ? 'warning' : 'primary'"
                  class="btn-back float-right"
                  type="submit"
                  ><font-awesome-icon icon="save"></font-awesome-icon>
                  {{ $route.params.id !== undefined ? 'Update' : 'Save' }}
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <!-- <b-modal id="bv-modal-tax" hide-footer>
          <template v-slot:modal-title>
            <h5 class="text-transform">Add Tax</h5>
          </template>
          <form v-on:submit.prevent="doAddTax()">
            <div class="d-block">
              <label for=""><strong>Name *</strong></label>
              <b-form-input v-model="formData.name" required placeholder="Enter Name"></b-form-input
              ><br />
              <label for=""><strong>Value *</strong></label>
              <b-form-input
                type="number"
                v-model="formData.value"
                required
                placeholder="Enter Value"
              ></b-form-input>
            </div>
            <b-button class="mt-4" @click="$bvModal.hide('bv-modal-tax')"
              ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button
            >
            <b-button variant="primary" type="submit" class="mt-4 float-right"
              ><font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button
            >
          </form>
        </b-modal> -->

        <b-modal id="bv-modal-tax" hide-footer>
          <template v-slot:modal-title>
            <h5 class="text-transform">Add Tax</h5>
          </template>
          <div>
            <form v-on:submit.prevent="doAddTax()">
              <div class="d-block">
                <b-form-input
                  v-model="formData.name"
                  required
                  placeholder="Enter Name"
                ></b-form-input
                ><br />
                <b-form-input
                  type="number"
                  v-model="formData.value"
                  required
                  placeholder="Enter Value"
                ></b-form-input>
                  <br>
                  <label for=""><strong>Journal Account*</strong></label>
                  <v-select
                    id="mySelect"
                    label="text"
                    v-model="formData.journalAccount"
                    :options="journalAccountList"
                    :reduce="(text) => text.value"
                    class="style-chooser"
                    placeholder="search journal account..."
                  >
                    <template #search="{attributes, events}">
                      <input
                        class="vs__search"
                        :required="!formData.journalAccount"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                <!-- <b-button class="mt-4" @click="$bvModal.hide('bv-modal-tax')"
            >
              ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button> -->
                <b-button variant="success" class="btn btn-sm mt-3 mb-3 float-right" type="submit"
                  ><font-awesome-icon icon="plus"></font-awesome-icon> Add</b-button
                >
                <b-table
                  :fields="fields"
                  :items="tax"
                  responsive="sm"
                  class="align-items-center mt-3 text-center"
                >
                  <template #cell(name)="row">
                    <p class="align-items-center my-auto font-weight-bold">{{ row.item.name }}</p>
                  </template>

                  <template #cell(actions)="row">
                    <!-- <a
                    v-if="canDelete"
                    v-on:click="deleteTax(row)"
                    v-b-tooltip.hover.left
                    title="Delete"
                    class="btn-op icon-delete mr-2"
                  ></a>
                  <a
                    v-else
                    v-on:click="deleteTax()"
                    v-b-tooltip.hover.left
                    title="Delete"
                    class="btn-op icon-delete mr-2"
                  ></a> -->

                    <a
                      v-if="canEdit"
                      v-on:click="showModalEditTax(row)"
                      v-b-tooltip.hover.right
                      title="Edit"
                      class="btn-op icon-edit mr-1"
                    ></a>
                    <a
                      v-else
                      v-on:click="showModalEditTax(row)"
                      v-b-tooltip.hover.right
                      title="Edit"
                      class="btn-op icon-edit mr-1"
                    ></a>
                  </template>
                </b-table>
              </div>
            </form>
          </div>
        </b-modal>
        <b-modal id="bv-modal-tax-edit" hide-footer>
          <template v-slot:modal-title>
            <h5 class="text-transform">Edit Tax</h5>
          </template>
          <form v-on:submit.prevent="doEditTax()">
            <div class="d-block">
              <label for=""><strong>Name *</strong></label>
              <b-form-input v-model="formData.name" required placeholder="Enter Name"></b-form-input
              ><br />
              <label for=""><strong>Value *</strong></label>
              <b-form-input
                type="number"
                v-model="formData.value"
                required
                placeholder="Enter Value"
              ></b-form-input>
              <br>
              <label for=""><strong>Journal Account*</strong></label>
              <v-select
                id="mySelect"
                label="text"
                v-model="formData.journalAccount"
                :options="journalAccountList"
                :reduce="(text) => text.value"
                class="style-chooser"
                placeholder="search customer..."
              >
                <template #search="{attributes, events}">
                  <input
                    class="vs__search"
                    :required="!formData.journalAccount"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
            </div>
            <b-button class="mt-4" @click="$bvModal.hide('bv-modal-tax-edit')"
              ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button
            >
            <b-button variant="warning" type="submit" class="mt-4 float-right"
              ><font-awesome-icon icon="save"></font-awesome-icon>
              <b-spinner type="grow" v-if="loadingButton" label="Spinning"></b-spinner>
              Update</b-button
            >
          </form>
        </b-modal>
        <b-modal id="bv-modal-payment" hide-footer>
          <template v-slot:modal-title>
            <h5 class="text-transform">Add Payment</h5>
          </template>
          <form v-on:submit.prevent="submitPayment()">
            <div class="d-block">
              <b-row class="mt-2">
                <b-col md="3">
                  <label for="" class="labels">Payment Date</label>
                </b-col>
                <b-col md="1"></b-col>
                <b-col md="8">
                  <b-form-datepicker
                    type="date"
                    :min="min"
                    class="form-control"
                    v-bind:class="errors.has('dueDate') ? 'is-invalid' : ''"
                    data-vv-as="dueDate"
                    name="dueDate"
                    v-model="invoiceHistoryPayment.paymentDate"
                    placeholder="Date"
                  />
                </b-col>
              </b-row>

              <b-row class="mt-2">
                <b-col md="3">
                  <label for="" class="labels">payment ref number</label>
                </b-col>
                <b-col md="1"></b-col>
                <b-col md="8">
                  <b-form-input
                    type="text"
                    v-model="invoiceHistoryPayment.paymentRefNumber"
                    placeholder="ref number .."
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col md="3">
                  <label for="" class="labels">payment to</label>
                </b-col>
                <b-col md="1"></b-col>
                <b-col md="8">
                  <b-form-input
                    type="text"
                    v-model="invoiceHistoryPayment.paymentTo"
                    placeholder="exp BCA .."
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col md="3">
                  <label for="" class="labels">Payment Ammount</label>
                </b-col>
                <b-col md="1"></b-col>
                <b-col md="8">
                  <b-form-input
                    type="number"
                    v-model="invoiceHistoryPayment.paymentAmmount"
                    placeholder="payment ammount .."
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col md="3">
                  <label for="" class="labels">Note</label>
                </b-col>
                <b-col md="1"></b-col>
                <b-col md="8">
                  <b-form-input
                    type="text"
                    v-model="invoiceHistoryPayment.paymentNote"
                    placeholder="note .."
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col md="3">
                  <label for="" class="labels">Change by</label>
                </b-col>
                <b-col md="1"></b-col>
                <b-col md="8">
                  {{ $store.getters['account/accountData'].firstName }}
                  {{ $store.getters['account/accountData'].lastName }}
                  <b-form-input
                    v-model="invoiceHistoryPayment.changedBy"
                    style="visibility: hidden;"
                    readonly
                  >
                  </b-form-input>
                </b-col>
              </b-row>
            </div>
            <b-button class="mt-4" @click="$bvModal.hide('bv-modal-tax')"
              ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button
            >
            <b-button variant="primary" type="submit" class="mt-4 float-right"
              ><font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button
            >
          </form>
        </b-modal>
      </form>
    </b-card>
  </div>
</template>

<script>
import wysiwyg from 'vue-wysiwyg';
import Vue from 'vue';
import vSelect from 'vue-select';
import MyCurrencyInput from '../../../components/MyCurrencyInput.vue';
import 'vue-select/dist/vue-select.css';
Vue.use(vSelect, 'v-select');
Vue.use(wysiwyg, {
  hideModules: {
    headings: true,
    code: true,
    link: true,
    image: true,
    table: true,
    unorderedList: true,
    separator: true,
  },
}); // config is optional. more below

export default {
  components: {MyCurrencyInput},
  name: 'customer-form',
  data: function() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const minDate = new Date(today);
    minDate.setDate(minDate.getDate() - 0);

    return {
      loadingButton: false,
      searchShow: false,
      isLoading: false,
      isCustomItem: false,
      isDeleted: false,
      value: '',
      min: minDate,
      itemsList: [],
      apiUrl: {
        invoice: window.AppConfig.apiUrl + 'invoice',
        customer: window.AppConfig.apiUrl + 'customer',
        itemList: window.AppConfig.apiUrl + 'item-list',
        // profile: window.AppConfig.apiUrl + 'profile?active=1'
      },
      dataItem: [],
      selectedItemsList: '',
      fetchedItems: [], //dari server
      availableItems: [],
      selectedItems: [], // user copy, yg dikerjain sama user
      selectedItem: {
        uuid: null,
        itemUuid: null,
      },
      // price of selected item.
      itemPrice: 0,
      // array of find
      tax: [],
      // single item from database
      fields: [
        {
          key: 'name',
          label: 'Tax Name',
        },
        {
          key: 'value',
          label: 'Value',
        },
        {
          key: 'journalAccount.journalAccountName',
          label: 'Journal Account'
        },
        {
          key: 'actions',
          label: '',
        },
      ],
      canDelete: {
        type: Boolean,
        required: false,
        default: true,
      },
      canEdit: {
        type: Boolean,
        required: false,
        default: true,
      },
      customerValue: '',
      availableItems: [],
      selectedItem: {},
      company: '',
      companyUuid: '',
      branch: '',
      branchUuid: '',
      taxesValue: '',
      currency: '',
      totalSubtotal: 0,
      totalTaxValue: 0,
      model: {
        isSigned: null,
        isStamp: null,
        customer: null,
        signedBy: null,
        invoiceId: '',
        referenceTitle: '',
        submittedDate: new Date(),
        subject: '',
        invoicePic: '',
        bankAccount: null,
        tax: '',
        taxValue: null,
        invoiceDueDate: '',
        invoiceStartDate: '',
        status: null,
        invoiceItem: [],
        invoiceHistoryPayment: [],
        note: '',
        normalPrice: '',
        corporatePrice: '',
        createdBy: '',
        submittedBy: this.$store.getters['account/accountData'].uuid,
      },
      invoiceHistoryPayment: {
        paymentDate: '',
        changedBy: this.$store.getters['account/accountData'].uuid,
        paymentRefNumber: '',
        paymentTo: '',
        paymentAmmount: '',
        paymentNote: '',
      },
      allPayments: [],
      allPayment: {},

      modelValidations: {
        // taxValue: {
        //   required: true
        // }
      },
      formData: {
        name: null,
        value: null,
        note: '',
        uuid: null,
        journalAccount: null
      },
      bankList: [],
      taxList: [],
      taxListTable: [],
      customerList: [],
      profileList: [],
      employeeList: [],
      customerSales: null,
      uuidTax: '',
      fullNameProfile: '',
      invoiceSeleted: {},
      invoiceSeleteds: [],
      journalAccountList: []
    };
  },
  watch: {
    // 'fakeTableFilter.name'(value) {
    //   this.tableFilter.name = value ? 1 : null;
    //   this.doFilter();
    // },
    'model.customer'(value) {
      this.getCustomerByValue(value);
      // console.log(value);
    },

    'model.taxValue'(value) {
      this.getTaxByValue(value);
    },

    'tableFilter.name'() {
      this.doFilter();
    },

    'this.invoiceHistoryPayment'(value) {
      console.log(value);
    },

    // 'taxList.uuid'(value) {
    //   this.getTaxValue(value);
    // },

    // 'formData.uuid'(value){
    //   this.showModalEditTax(value);
    //   console.log('uuid ?',value);
    // }
  },
  methods: {
    /*
     * get detail of quotation data from database quotation
     */
    initData() {
      if (this.$route.params.id !== undefined) {
        this.fetchInvoiceDetail();
      }
    },

    showSearch() {
      this.searchShow = !this.searchShow;
    },

    // submitPayment() {
    //   this.$http.patch(window.AppConfig.apiUrl + 'invoice-payment')
    //   this.allPayments.push({ ...this.invoiceHistoryPayment });
    //   this.$bvModal.hide('bv-modal-payment');

    //   console.log(this.allPayments);
    // },

    /*
     * post quotation data to quotation database
     */
    /**
     * @function doEdit()
     * push all item changes to server.
     */
    doEdit() {
      this.loadingButton = true;
      const toSubmit = this.selectedItems.map((selectedItem) => ({
        uuid: selectedItem.uuid ? selectedItem.uuid : '',
        itemList: selectedItem.isCustomItem ? '' : selectedItem.itemUuid || selectedItem.itemUuid,
        quantity: selectedItem.orderQuantity,
        discount: selectedItem.discount,
        customPrice: selectedItem.price,
        delete: selectedItem.isDeleted ? 1 : 0,
        // taxValue: selectedItem.taxValue.value ? "" : selectedItem.taxValue.value
      }));
      const payment = this.allPayments.map((allPayment) => ({
        uuid: allPayment.uuid ? allPayment.uuid : '',
        paymentDate: allPayment.paymentDate,
        paymentRefNumber: allPayment.paymentRefNumber,
        paymentTo: allPayment.paymentTo.uuid,
        paymentAmmount: allPayment.paymentAmmount,
        paymentNote: allPayment.paymentNote,
        changedBy: this.$store.getters['account/accountData'].uuid,
      }));
      const changedByUuid = this.invoiceHistoryPayment.changedBy;
      this.$validator.validateAll().then((res) => {
        if (res) {
          let formData = new FormData();
          formData.append('invoiceId', this.model.invoiceId);
          formData.append('subject', this.model.subject);
          formData.append('invoicePic', this.model.invoicePic);
          formData.append('invoiceDueDate', this.model.invoiceDueDate);
          formData.append('submittedDate', this.model.submittedDate);
          formData.append('invoiceStartDate', this.model.invoiceStartDate);
          formData.append('customer', this.model.customer);
          formData.append('bankAccount', this.model.bankAccount);
          formData.append('note', this.model.note);
          formData.append('isSigned', this.model.isSigned);
          formData.append('isStamp', this.model.isStamp);
          formData.append('taxValue', this.model.taxValue);
          formData.append('signedBy', this.model.signedBy);
          formData.append('createdBy', this.model.createdBy);
          formData.append('invoiceItem', JSON.stringify(toSubmit));
          formData.append('invoiceHistoryPayment', JSON.stringify(payment, changedByUuid));
          console.log('data yg trkirim', formData);
          this.$http
            .patch(this.apiUrl.invoice + '/' + this.$route.params.id, formData)
            .then((response) => {
              this.$store.dispatch('notification/success', 'Invoice has been Updated.');
              window.location.href = document.URL.replace('/edit', '');
            })
            .catch((error) => {
              this.$store.dispatch('notification/error', error);
              this.loadingButton = false;
            });
        } else {
          this.loadingButton = false;
          swal('', 'Please fill the required fields!', 'info', {
            buttons: false,
            timer: 2000,
          });
        }
      });
    },

        //get bank account
    getBankList() {
      this.$http
        .get(window.AppConfig.apiUrl + 'bank-account')
        .then((response) => {
          this.bankList = [];
          response.data._embedded.bank_account.forEach((data) => {
            this.bankList.push({
              value: data.uuid,
              text: data.bank,
            });
          });
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },
    //fetch data dari api berdasarkan params uuid
    fetchInvoiceDetail() {
      this.isLoading = true;
      this.$http
        .get(this.apiUrl.invoice + '/' + this.$route.params.id)
        .then((response) => {
          console.log('invoice', response);
          this.model.customer = response.data.customer.uuid;
          this.model.createdBy = response.data.createdBy.uuid;
          this.model.signedBy = response.data.signedBy.uuid;
          this.model.invoiceId = response.data.invoiceId;
          this.model.invoicePic = response.data.invoicePic;
          this.model.isSigned = response.data.isSigned;
          this.model.isStamp = response.data.isStamp;
          this.model.subject = response.data.subject;
          this.model.submittedDate = response.data.submittedDate;
          this.model.invoiceStartDate =
            response.data.invoiceStartDate !== null
              ? this.$moment(response.data.invoiceStartDate).format('YYYY-MM-DD')
              : '-';
          this.model.invoiceDueDate =
            response.data.invoiceDueDate !== null
              ? this.$moment(response.data.invoiceDueDate).format('YYYY-MM-DD')
              : '-';
          this.model.invoiceTotal = response.data.invoiceTotal;
          this.model.invoiceUnpaidBill = response.data.invoiceUnpaidBill;
          this.model.note = response.data.note;

          this.model.taxValue =
            response.data.taxValue !== null ? response.data.taxValue.uuid : null;
          if (response.data.invoiceItem) {
            this.selectedItems = response.data.invoiceItem.map((selectedItem) => {
              console.log('ini isi selectedItem(invoiceItem): ', selectedItem);
              const itemName = selectedItem.customItem
                ? selectedItem.customItem
                : selectedItem.itemList.name;
              return {
                uuid: selectedItem.uuid ? selectedItem.uuid : '',
                itemUuid: selectedItem.itemList ? selectedItem.itemList.uuid : '',
                name: itemName,
                corporatePrice: selectedItem.itemList.corporate_price
                  ? selectedItem.itemList.corporate_price
                  : '',
                normalPrice: selectedItem.itemList.normal_price
                  ? selectedItem.itemList.normal_price
                  : '',
                orderQuantity: selectedItem.quantity,
                discount: selectedItem.discount,
                // amount: itemAmount,
                // customItem: selectedItem.customItem ? selectedItem.customItem : '',
                price: selectedItem.customPrice > 0 | selectedItem.customPrice !==null ? selectedItem.customPrice : 0,
                isDeleted: false,
                isNewItem: false,
              };
            });
          }
          if (response.data.invoiceHistoryPayment) {
            this.allPayments = response.data.invoiceHistoryPayment.map((allPayment) => {
              console.log('historyPayment', allPayment);
              return {
                uuid: allPayment.uuid ? allPayment.uuid : '',
                aphUuid: allPayment.uuid,
                paymentNote: allPayment.paymentNote,
                paymentTo: allPayment.paymentTo,
                paymentAmmount: allPayment.paymentAmmount,
                paymentDate: allPayment.paymentDate,
                paymentRefNumber: allPayment.paymentRefNumber,
              };
            });
          }
          if(response.data.bankAccount !==null){
          this.model.bankAccount = response.data.bankAccount.uuid;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/success', error);
        });
    },

    getEmployee() {
      this.$http
        .get(window.AppConfig.apiUrl + 'profile?role=admin')
        .then((response) => {
          this.employeeList = [
            {
              value: null,
              text: 'Select Name',
            },
          ];
          response.data._embedded.profile.forEach((data) => {
            let names = data.firstName + '\xa0' + data.lastName;
            this.fullName = names;
            this.employeeList.push({
              value: data.uuid,
              text: this.fullName,
            });
          });
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },

    /**
     * format price
     */
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    /**
     * get data customer from database
     */
    getCustomer() {
      this.$http
        .get(window.AppConfig.apiUrl + 'customer?limit=100')
        .then((response) => {
          this.customerList = [];
          response.data._embedded.customer.forEach((data) => {
            this.customerSales = data.salesType;
            this.customerList.push({
              value: data.uuid,
              text: data.name,
            }),
              (this.currency = data.account.currency);
          });
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },

    getCustomerByValue(uuid) {
      this.customerValue = '';
      this.$http
        .get(window.AppConfig.apiUrl + 'customer' + '/' + uuid)
        .then((response) => {
          this.customerValue = response.data.salesType;
          if (this.customerValue === 'Personal') {
            this.getTotalPersonalOrder();
            this.getDiscTotalPersonal();
            this.getSubtotalPersonal();
            this.getTotalPersonal();
          } else {
            this.getTotalCorporateOrder();
            this.getDiscTotalCorporate();
            this.getSubtotalCorporate();
            this.getTotalCorporate();
          }
          console.log('value ny adalah', this.customerValue);
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },

    /**
     * get tax value from tax category
     */
    getTaxByValue(uuid) {
      let totalTaxValue = 0;
      this.$http
        .get(window.AppConfig.apiUrl + 'tax-value' + '/' + uuid)
        .then((response) => {
          this.taxesValue = response.data.value;
          this.totalTaxValue = (this.taxesValue * this.taxesValue) / 100;
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },

    /**
     * get data tax category from database
     */
    getTaxValue() {
      this.$http
        .get(window.AppConfig.apiUrl + 'tax-value?limit=100')
        .then((response) => {
          this.taxList = [
            {
              value: null,
              text: 'Select Tax',
            },
          ];
          response.data._embedded.tax_value.forEach((data) => {
            this.taxList.push({
              value: data.uuid,
              text: data.name,
            });
          });
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },

    /**=============================================================
     *    MODAL INPUT PAYMENT HISTORY
     * ============================================================= */
    showFormPayment() {
      this.invoiceHistoryPayment.paymentDate = null;
      this.invoiceHistoryPayment.paymentRefNumber = null;
      this.invoiceHistoryPayment.paymentTo = null;
      this.invoiceHistoryPayment.paymentAmmount = null;
      this.invoiceHistoryPayment.paymentNote = null;
      (this.invoiceHistoryPayment.changedBy = this.$store.getters['account/accountData'].uuid),
        this.$bvModal.show('bv-modal-payment');
    },

    /**=============================================================== */

     /**
     * show modal for input data tax to database
     */
    showModalTax() {
      this.formData.name = null;
      this.formData.value = null;
      this.formData.journalAccount = null;
      this.$bvModal.show('bv-modal-tax');
    },

    /** ini button untuk menampilkan form edit berbentuk modal */
     showModalEditTax(row) {
      this.uuidTax = row.item.uuid;
      if (row !== undefined) {
        this.$bvModal.show('bv-modal-tax-edit');
        this.formData.name = row.item.name;
        this.formData.value = row.item.value;
        this.formData.journalAccount = row.item.journalAccount.journalAccountName
        //  console.log('ini row', this.uuidTax);
      } else {
        console.log('no data rowuuid :');
      }
    },
    /**
     * post data tax to database
     */
    doAddTax() {
      this.isLoading = true;
      this.$http
        .post(window.AppConfig.apiUrl + 'tax-value', {
          name: this.formData.name,
          value: this.formData.value,
          journalAccount: this.formData.journalAccount
        })
        .then((resp) => {
          this.isLoading = false;
          this.formData.name = null;
          this.formData.note = null;
          this.formData.journalAccount = null
          this.getTax();
          this.getTaxValue();
          this.$bvModal.hide('bv-modal-tax-edit');
          this.$store.dispatch('notification/success', 'Tax has been added');
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },

    doEditTax() {
      this.loadingButton = true;
      this.$http
        .patch(window.AppConfig.apiUrl + 'tax-value' + '/' + this.uuidTax, {
          name: this.formData.name,
          value: this.formData.value,
          journalAccount: this.formData.journalAccount
        })
        .then((resp) => {
          this.loadingButton = false;
          this.formData.name = null;
          this.formData.value = null;
          this.formData.journalAccount = null;
          this.$bvModal.hide('bv-modal-tax-edit');
          this.getTax();
          this.$store.dispatch('notification/success', 'Tax has been update');
        })
        .catch((error) => {
          this.loadingButton = false;
          this.$store.dispatch('notification/error', error);
        });
    },

    getJournal(){
      this.$http.get(window.AppConfig.apiUrl + 'journal-account?journalAccountType=D').then((resp)=>{
        this.journalAccountList = [];
        resp.data._embedded.journal_account.forEach(data =>{
          this.journalAccountList.push({
            value: data.uuid,
            text: data.journalAccountCode + ' - ' + data.journalAccountType + ' - ' + data.journalAccountName
          })
        })
      })
    },
    // getTaxUuid(uuid){
    //   this.$http.get(window.AppConfig.apiUrl + 'tax-value' + '/' + uuid).then(resp => {
    //     this.formData.name = resp.data.name;
    //     this.formData.value = resp.data.value;
    //     console.log('edit ',uuid);
    //   }).catch((error) => {
    //     this.$store.dispatch('notification/error', error);
    //   });
    // },

    getTax() {
      this.$http.get(window.AppConfig.apiUrl + 'tax-value').then((response) => {
        this.tax = [];
        this.taxListTable = [
          {
            value: null,
            text: 'Please Select Tax',
          },
        ];
        response.data._embedded.tax_value.forEach((data) => {
          this.tax = response.data._embedded.tax_value;
          this.taxListTable.push({
            value: data.uuid,
            text: data.name,
          });
        });
      });
    },

    deleteTax(row) {
      this.isLoading = true;
      this.$http
        .delete(window.AppConfig.apiUrl + 'tax-value' + '/' + row.item.uuid)
        .then(() => {
          this.isLoading = false;
          // this.$bvModal.hide('bv-modal-merk')
          this.getTax();
          this.$store.dispatch('notification/success', 'Tax deleted successfull');
        })
        .catch((error) => {
          // this.isLoading = true
          this.$store.dispatch('notification/error', error);
        });
    },

    /**
     * @function fetchAvailableItems
     * @async
     * fetch items for sale from API then remap it
     * by adding OrderQuantity and isManuallyEntered
     */
    fetchAvailableItems: async function() {
      const response = await this.$http.get(window.AppConfig.apiUrl + 'item-list');
      this.dataItem = response.data._embedded.item_list.name;
      this.availableItems = response.data._embedded.item_list.map((availableItem) => ({
        itemUuid: availableItem.uuid,
        uuid: availableItem.uuid,
        name: availableItem.name,
        normalPrice: availableItem.normalPrice,
        corporatePrice: availableItem.corporatePrice,
        taxValue: availableItem.taxValue,
        orderQuantity: 0,
        discount: 0,
        amount: 0,
        isCustomItem: false,
        isDeleted: false,
        isNewItem: true,

        // timezone: availableItem.account.currency
      }));
    },

    // getAvailableItems (name) {
    //   if(name.length > 1);
    //   this.$http.get(this.apiUrl.quotation + '?name=').then(response => {
    //    response.data._embedded.quotation.forEach(data => {
    //        this.itemList.push({
    //        value: data.uuid,
    //        text: data.name
    //        })
    //    })
    //    })
    // },

    /**
     * @function addToSelected
     * @param {{ isCustomItem, name, orderQuantity, price, discount, uuid, isDeleted, isNewItem }} item
     * add the item object into selectedItems array.
     */
    addToSelected: function(item) {
      this.selectedItems.push({ ...item });
    },

    /**
     * @function createCustomItem
     * create an empty input fields to enter items
     * that is currently not in the database.
     */
    createCustomItem: function() {
      this.addToSelected({
        uuid: '',
        name: '',
        price: 0,
        taxValue: null,
        orderQuantity: 0,
        discount: 0,
        amount: 0,
        isCustomItem: true,
        isDeleted: false,
        isNewItem: true,
      });
      console.log(this.selectedItems);
    },

    /**
     * @function deleteSelectedItem
     * @param { Number } index
     * delete an item from the selectedItems array,
     * and from the quotation form.
     */
    deleteSelectedItem: function(index) {
      this.selectedItems.splice(index, 1);
    },

    /**
     * if the item is newly added, remove it completely from the selectedItems array.
     * othwerwise just mark it as deleted
     * */
    deleteFromSelectedItems(index) {
      this.selectedItems[index].isDeleted = true;
      if (this.selectedItems[index].isNewItem) this.selectedItems.splice(index, 1);
    },

    /**
     * @function getRemainingAvailableItems
     * get availableItems that is not yet added into selectedItems
     * by extracting UUIDs from selectedItems into selectedItemsUUID array
     * then filter out items whose UUID is in the selectedItemsUUID array.
     */

    getRemainingAvailableItems: function() {
      const selectedItemsUUID = this.selectedItems.map(
        ({ itemUuid, isDeleted }) => isDeleted || itemUuid,
      );
      return this.availableItems.filter(
        (availableItem) => !selectedItemsUUID.includes(availableItem.itemUuid),
      );
    },

    /*
     *counting subtotal
     */
    getSubtotalPersonal: function() {
      let subtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, normalPrice }) => {
        subtotal = subtotal + orderQuantity * normalPrice;
      });
      return subtotal;
    },

    getSubtotalCorporate: function() {
      let subtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, corporatePrice }) => {
        subtotal = subtotal + orderQuantity * corporatePrice;
      });
      return subtotal;
    },

    getSubtotalCustom() {
      let subtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, price }) => {
        subtotal = subtotal + orderQuantity * price;
      });
      return subtotal;
    },

    /**
     * counting disctotal
     */
    getDiscTotalPersonal: function() {
      let disctotal = 0;
      this.selectedItems.forEach(({ orderQuantity, normalPrice, discount }) => {
        disctotal = disctotal + (orderQuantity * normalPrice * discount) / 100;
      });
      return disctotal;
    },

    getDiscTotalCorporate: function() {
      let disctotal = 0;
      this.selectedItems.forEach(({ orderQuantity, corporatePrice, discount }) => {
        disctotal = disctotal + (orderQuantity * corporatePrice * discount) / 100;
      });
      return disctotal;
    },

    getDiscTotalCustom() {
      let disctotal = 0;
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        disctotal = disctotal + (orderQuantity * price * discount) / 100;
      });
      return disctotal;
    },

    /*
     * counting total tax
     */
    getTaxValuesPersonal: function() {
      let subtotal = 0;
      let taxValued = 0;
      this.selectedItems.forEach(({ orderQuantity, normalPrice, discount }) => {
        subtotal =
          subtotal + (orderQuantity * normalPrice - (orderQuantity * normalPrice * discount) / 100);
        taxValued = (subtotal * this.taxesValue) / 100;
      });
      return taxValued;
    },

    getTaxValuesCorporate: function() {
      let subtotal = 0;
      let taxValued = 0;
      this.selectedItems.forEach(({ orderQuantity, corporatePrice, discount }) => {
        subtotal =
          subtotal +
          (orderQuantity * corporatePrice - (orderQuantity * corporatePrice * discount) / 100);
        taxValued = (subtotal * this.taxesValue) / 100;
      });
      return taxValued;
    },

    getTaxValuesCustom: function() {
      let subtotal = 0;
      let taxValued = 0;
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        subtotal = subtotal + (orderQuantity * price - (orderQuantity * price * discount) / 100);
        taxValued = (subtotal * this.taxesValue) / 100;
      });
      return taxValued;
    },

    /*
     * counting total price
     */

    getTotalCorporateOrder() {
      let totalOrder = 0;
      this.selectedItems.forEach(({ orderQuantity, corporatePrice, discount }) => {
        totalOrder =
          totalOrder +
          (orderQuantity * corporatePrice - (orderQuantity * corporatePrice * discount) / 100);
      });
      return totalOrder;
    },

    getTotalPersonalOrder() {
      let totalOrder = 0;
      this.selectedItems.forEach(({ orderQuantity, normalPrice, discount }) => {
        totalOrder =
          totalOrder +
          (orderQuantity * normalPrice - (orderQuantity * normalPrice * discount) / 100);
      });
      return totalOrder;
    },

    getTotalCustomOrder() {
      let totalOrder = 0;
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        totalOrder =
          totalOrder + (orderQuantity * price - (orderQuantity * price * discount) / 100);
      });
      return totalOrder;
    },

    /**
     *
     ********************************** counting grant total here ****************************
     */

    getTotalPersonal: function() {
      let subtotal = 0;
      let totalSubtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, normalPrice, discount }) => {
        subtotal =
          subtotal + (orderQuantity * normalPrice - (orderQuantity * normalPrice * discount) / 100);
        totalSubtotal = subtotal + (subtotal * this.taxesValue) / 100;
      });
      return totalSubtotal;
    },

    getTotalCorporate: function() {
      let subtotal = 0;
      let totalSubtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, corporatePrice, discount }) => {
        subtotal =
          subtotal +
          (orderQuantity * corporatePrice - (orderQuantity * corporatePrice * discount) / 100);
        totalSubtotal = subtotal + (subtotal * this.taxesValue) / 100;
      });
      return totalSubtotal;
    },

    getTotalCustom: function() {
      let subtotal = 0;
      let totalSubtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        subtotal = subtotal + (orderQuantity * price - (orderQuantity * price * discount) / 100);
        totalSubtotal = subtotal + (subtotal * this.taxesValue) / 100;
      });
      return totalSubtotal;
    },

    /************************************************************************************ */

    goBack() {
      window.goBack(this);
    },

    getMonth(value) {
      if (value !== null) {
        return this.$moment(value).format('MM');
      } else {
        return '-';
      }
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD');
      } else {
        return '-';
      }
    },

    getFullYear(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY');
      } else {
        return '-';
      }
    },
  },

  mounted: function() {
    this.fetchAvailableItems();
    this.getRemainingAvailableItems();
    this.getCustomer();
    this.getTaxValue();
    this.formatPrice();
    this.initData();
    this.getTax();
    this.getDateTime();
    this.getBankList()
    // this.getCustomerName();
    this.getEmployee();
    this.getFullYear();
    this.getMonth();
    this.getJournal();
    this.getTotalCustomOrder();
    this.getTotalCustom();
    this.getSubtotalCustom();
    this.getDiscTotalCustom();
    this.getTaxValuesCustom();
    this.fetchInvoiceDetail();
    // this.getTaxUuid();
  },
};
</script>
<style>
@import '~vue-wysiwyg/dist/vueWysiwyg.css';
#mySelect .v-select .dropdown-toggle ::placeholder {
  border: none;
  color: #d3d3d3 !important;
}
</style>
